import { createContext, useContext, type ReactNode } from 'react';

/**
 * Decouples the schema-form media/entity pickers (§4.7) from the feature modules that
 * implement them. The app shell provides resolvers; widgets call them to get an id back.
 */
export interface PickerApi {
  /** Open the media library picker; resolves to a media id or null if cancelled. */
  pickMedia: (opts?: { restricted?: boolean }) => Promise<string | null>;
  /** Open a content collection picker; resolves to an entity id or null. */
  pickEntity: (collection: string) => Promise<string | null>;
  /** Render a small thumbnail/label for a chosen media id (for the picker field preview). */
  MediaPreview: (props: { id: string | null }) => ReactNode;
}

const noop: PickerApi = {
  pickMedia: async () => null,
  pickEntity: async () => null,
  MediaPreview: () => null,
};

const PickerContext = createContext<PickerApi>(noop);

export function PickerProvider({ value, children }: { value: PickerApi; children: ReactNode }) {
  return <PickerContext.Provider value={value}>{children}</PickerContext.Provider>;
}

export function usePicker(): PickerApi {
  return useContext(PickerContext);
}
